import { Filter } from '@/interfaces/filter.interface'
import { APIProvider } from '@/models/api/provider.model'
import { ProvidersServices } from '@/services/modules/providers.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ProvidersStore extends VuexModule {
    providers: object[] = []
    providersPaginate: object[] = []
    providerForm: object|null = null

    @Mutation
    updateProviders (newProviders: object[]) {
        this.providers = newProviders
    }

    @Mutation
    updateProvidersPaginate (newProviders: object[]) {
        this.providersPaginate = newProviders
    }

    @Mutation
    updateProvider (newProvider: object) {
        this.providerForm = newProvider
    }

    @Action
    getProviders () {
        return new Promise((resolve) => {
            ProvidersServices.getProviders()
                .then(resp => {
                    store.commit('updateProviders', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProvidersPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ProvidersServices.getProvidersPaginate(newParams)
                .then(resp => {
                    store.commit('updateProvidersPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProvidersById (id: number) {
        return new Promise((resolve) => {
            ProvidersServices.getProvidersById(id)
                .then(resp => {
                    store.commit('updateProvider', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editProviders (params: APIProvider) {
        params = new APIProvider(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIProvider)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProvidersServices.editProviders(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createProviders (params: APIProvider) {
        params = new APIProvider(params)

        params.providerEnabled = 1

        return new Promise((resolve) => {
            if (!(params instanceof APIProvider)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProvidersServices.createProviders(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteProviders (id: number) {
        return new Promise((resolve) => {
            ProvidersServices.deleteProviders(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreProviders (id: number) {
        return new Promise((resolve) => {
            ProvidersServices.restoreProviders(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
